var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelpcard1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 31,
    viewBox: "0 0 34 31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-3-4h40v40H-3z",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#80959D",
    d: "M.5.5h33v12H.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgba(21, 87, 191, 0.7)",
    d: "M3 3h28v7H3z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#80959D",
    d: "M.002 18.5h33.996M.002 22.5h33.996M.002 26.5h33.996M.002 30.5h24.996"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpcard1);
export default __webpack_public_path__ + "static/media/helpcard1.962e0545d4df456317c5208e2ebaa130.svg";
export { ForwardRef as ReactComponent };